import React from "react";
import LpCta from "./LpCta";

const LpFinal = () => (
  <section className="section-pad bg-black text-white" data-testid="lp-final">
    <div className="aevos-container grid lg:grid-cols-12 gap-10 items-center">
      <div className="lg:col-span-8">
        <h2 className="font-display font-bold text-3xl md:text-5xl !text-white leading-[1.08]">
          Dê o primeiro passo para um emagrecimento com orientação e acompanhamento
        </h2>
        <p className="mt-5 text-white/80 text-base md:text-lg leading-relaxed max-w-2xl">
          Na consulta inicial, você terá espaço para apresentar suas dificuldades, entender o que
          precisa ser avaliado e conversar sobre um plano de cuidado compatível com sua saúde e sua
          rotina.
        </p>
      </div>
      <div className="lg:col-span-4 lg:text-right">
        <LpCta location="final">Agendar minha consulta</LpCta>
      </div>
    </div>
  </section>
);

export default LpFinal;
